import styled, { keyframes } from 'styled-components';
import { motion } from 'framer-motion';

const float = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-20px); }
  100% { transform: translateY(0px); }
`;

export const HeroContainer = styled.div`
  background: #0A091A;
  display: flex;
  justify-content: center;
  position: relative;
  padding: 42px 40px;
  z-index: 1;
  min-height: calc(100vh - 80px);
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    background: radial-gradient(circle at 70% 30%, rgba(133, 76, 230, 0.1) 0%, transparent 50%);
    pointer-events: none;
    z-index: -1;
  }
`;

export const HeroBg = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  opacity: 0.3;
  pointer-events: none;
`;

export const HeroInnerContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1300px;
  z-index: 2;

  @media (max-width: 960px) {
    flex-direction: column;
    text-align: center;
    gap: 80px;
  }
`;

export const HeroLeftContainer = styled.div`
  width: 100%;
  max-width: 700px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Label = styled.div`
  font-size: 13px;
  font-weight: 700;
  color: #854CE6;
  text-transform: uppercase;
  letter-spacing: 0.4em;
  margin-bottom: 8px;
`;

export const Title = styled.h1`
  font-size: 58px;
  font-weight: 800;
  color: #FFFFFF;
  line-height: 1.15;
  letter-spacing: -0.03em;

  span {
    color: #854CE6;
  }

  @media (max-width: 640px) {
    font-size: 42px;
  }
`;

export const SubTitle = styled.div`
  font-size: 18px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.5);
  max-width: 520px;
  font-weight: 400;

  @media (max-width: 960px) {
    margin: 0 auto;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 24px;

  @media (max-width: 960px) {
    justify-content: center;
  }
`;

export const PrimaryButton = styled.a`
  text-decoration: none;
  padding: 16px 36px;
  background: #FFFFFF;
  color: #0A091A;
  border-radius: 50px;
  font-weight: 700;
  font-size: 15px;
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 30px rgba(255, 255, 255, 0.1);
  }
`;

export const SecondaryButton = styled.a`
  text-decoration: none;
  padding: 16px 36px;
  background: transparent;
  color: #FFFFFF;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 50px;
  font-weight: 700;
  font-size: 15px;
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);

  &:hover {
    background: rgba(255, 255, 255, 0.05);
    border-color: rgba(255, 255, 255, 0.4);
    transform: translateY(-4px);
  }
`;

export const HeroRightContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  position: relative;

  @media (max-width: 960px) {
    justify-content: center;
  }
`;

export const VisualContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 500px;
  aspect-ratio: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    max-width: 350px;
  }
  @media (max-width: 480px) {
    max-width: 300px;
  }
`;

export const MainImageWrapper = styled.div`
  width: 76%;
  height: 76%;
  border-radius: 40% 60% 70% 30% / 40% 50% 60% 50%;
  overflow: hidden;
  background: rgba(133, 76, 230, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.1);
  animation: ${float} 10s ease-in-out infinite alternate;
  position: relative;
  z-index: 2;
`;

export const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.9;
`;

export const ConnectionSVG = styled.svg`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;
`;

export const FloatingNode = styled(motion.div)`
  position: absolute;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(133, 76, 230, 0.15);
  border: 1px solid rgba(133, 76, 230, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #854CE6;
  z-index: 3;
  backdrop-filter: blur(4px);
`;